import { render } from "./Rms.vue?vue&type=template&id=6d84b1fd"
import script from "./Rms.vue?vue&type=script&lang=js"
export * from "./Rms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__